// Browser-compatible ZATCA QR Code Generator
export function generateZatcaQR(data) {
  // Convert string to UTF-8 bytes
  const encodeUTF8 = (str) => new TextEncoder().encode(str);

  const seller = encodeUTF8(data.sellerName || "الأحمرى للنقل البري");
  const vatNumber = encodeUTF8(data.vatNumber || "");
  const timestamp = encodeUTF8(data.timestamp || new Date().toISOString());
  const totalAmount = encodeUTF8(String(data.totalAmount || "0.00"));
  const vatAmount = encodeUTF8(String(data.vatAmount || "0.00"));

  // Build TLV structure
  const tlvData = [
    1, seller.length, ...seller, // Tag 1: Seller name
    2, vatNumber.length, ...vatNumber, // Tag 2: VAT number
    3, timestamp.length, ...timestamp, // Tag 3: Timestamp
    4, totalAmount.length, ...totalAmount, // Tag 4: Total with VAT
    5, vatAmount.length, ...vatAmount, // Tag 5: VAT amount
  ];

  // Convert to Base64
  const uint8Array = new Uint8Array(tlvData);
  let binary = '';
  for (let i = 0; i < uint8Array.length; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }

  return btoa(binary);
}

// Helper to decode if needed
export function decodeZatcaQR(base64String) {
  const binary = atob(base64String);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}
